import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './ZH.css';
import img1 from '../Components/Images/TIJ/zx2.png';
import img2 from '../Components/Images/applications/zx1.png';
import img3 from '../Components/Images/applications/zx2.png';
import img4 from '../Components/Images/applications/zx3.png';
import img5 from '../Components/Images/applications/zx4.png';
import img6 from '../Components/Images/applications/zx5.png';
import img7 from '../Components/Images/applications/zx6.png';

function ZX2() {
  const images = [
    { id: 1, src: img2, alt: 'ZX Plus-2 printing batch codes on bottles in Dubai' },
    { id: 2, src: img3, alt: 'Industrial inkjet printer for product labeling in Dubai' },
    { id: 3, src: img4, alt: 'High-speed carton coding with ZX Plus-2 series printer' },
    { id: 4, src: img5, alt: 'Polybag marking machine for Dubai packaging industry' },
    { id: 5, src: img6, alt: 'Cosmetics expiration date printing with thermal inkjet' },
    { id: 6, src: img7, alt: 'Paper box coding system for Dubai manufacturers' },
  ];

  return (
    <div>
      <Helmet>
        <title>ZX Plus-2 Series Industrial Printer | Dubai Coding Solutions</title>
        <meta name="description" content="High-performance ZX Plus-2 industrial inkjet printers in Dubai for product coding, batch numbers, and barcode marking on various surfaces." />
        <meta name="keywords" content="ZX Plus-2 printer Dubai, industrial coding machine, product marking system, batch coding printer, Dubai manufacturing equipment, high-speed inkjet printer" />
        <meta property="og:title" content="ZX Plus-2 Series Industrial Printer - Dubai" />
        <meta property="og:description" content="Advanced coding solutions for Emiratis production lines with ZX Plus-2 series printers" />
        <link rel="canonical" href="https://www.yourwebsite.com/zx-plus2-printer" />
      </Helmet>

      <section className="handheld-printers">
        <Container>
          <Row className="">
            <Col className="text-center">
              <h1 className="section-title1 fonthead">
                ZX Plus-2 Series <span style={{color:"#3ec63e"}}>Industrial Coding Printers</span>
              </h1>
              <p className="section-subtitle1 mt-3">
                Advanced online inkjet printing solutions for Dubai's manufacturing sector
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center align-items-center">
            <Col xs={12} md={10} lg={6} className="text-center">
              <img 
                src={img1}
                className="img-fluid"
                style={{
                  maxHeight: "70vh",
                  width: "auto",
                  objectFit: "contain"
                }}
                alt="ZX Plus-2 series industrial printer - Professional coding solution for Dubai"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="product-specs">
        <Container>
          <h2 className="section-title1 fonthead mt-5 mb-2">Product Specifications</h2>
          
          <Card className="specs-card shadow-sm">
            <Card.Body>
              <Row>
                <Col md={4}>
                  <div className="feature-list">
                    <h3 className="specs-subtitle">Key Features</h3>
                    <ul className="list-unstyled">
                      <li className="feature-item">
                        <span className="feature-number">1.</span>
                        <span className="feature-text">Robust metallic construction with 7-inch capacitive touch screen</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">2.</span>
                        <span className="feature-text">Quick installation and intuitive interface for Emiratis operators</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">3.</span>
                        <span className="feature-text">Non-stop 24/7 operation for continuous production lines</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">4.</span>
                        <span className="feature-text">Multi-level user access control for secure operation</span>
                      </li>
                    </ul>
                  </div>
                </Col>
        
                <Col md={8}>
                  <div className="technical-details">
                    <h3 className="specs-subtitle">Industrial Applications in Dubai</h3>
                    
                    <Container className="py-2">
                      <Row className="g-4">
                        {images.map((image) => (
                          <Col key={image.id} xs={12} sm={6} md={4}>
                            <div className="image-card">
                              <img 
                                src={image.src} 
                                alt={image.alt}
                                className="img-fluid rounded"
                                style={{maxHeight:"150px"}}
                                loading="lazy"
                              />
                              <div className="image-overlay">
                                <p className="image-caption">{image.alt}</p>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </section>

      <section className="">
        <Container>
          <h2 className="section-title1 text-center fonthead mt-5 mb-2">Technical Specifications</h2>
          
          <Card className="specs-card shadow-lg">
            <Card.Body>
              <div className="table-responsive">
                <table className="table table-borderless specs-table">
                  <tbody>
                    <TableRow 
                      parameter="Print Technology" 
                      value="HP TIJ2.5 Thermal Inkjet for precise industrial marking" 
                    />
                    <TableRow 
                      parameter="Print Resolution Range" 
                      value="50-1,200 DPI (adjustable for different material surfaces)" 
                      isHighlighted={false}
                    />
                    <TableRow 
                      parameter="Optimal Printing Distance" 
                      value="2-5mm for consistent print quality" 
                    />
                    <TableRow 
                      parameter="Print Height Options" 
                      value="1-25.4mm (supports 1-2 print heads for wider coverage)" 
                    />
                    <TableRow 
                      parameter="Maximum Production Speed" 
                      value="Up to 120m/min (high-speed mode for Emiratis factories)" 
                      isHighlighted={false}
                    />
                    <TableRow 
                      parameter="Supported Marking Content" 
                      value="Production dates, expiry dates, batch numbers, text, images, barcodes, QR codes, database fields" 
                    />
                    <TableRow 
                      parameter="Ink System Compatibility" 
                      value="Aqueous, Solvent-based, and UV inks for various Emiratis industrial applications" 
                    />
                    <TableRow 
                      parameter="Available Ink Options" 
                      value="Black, White, Red, Yellow, Blue, Green, Invisible (for security marking)" 
                    />
                    <TableRow 
                      parameter="Multi-language Support" 
                      value="Arabic, English, French + 12 more (fully customizable for Dubai market)"
                      isHighlighted={false}
                    />
                    <TableRow 
                      parameter="Industrial Communication" 
                      value="RS232 standard for production line integration" 
                    />
                    <TableRow 
                      parameter="Connection Interfaces" 
                      value="USB, DB9 serial port, I/O, Encoder, Photocell sensor for automated operation" 
                    />
                    <TableRow 
                      parameter="Operating Environment" 
                      value="Temperature 0~45°C (Recommended: 20~30°C), Humidity 40~60%RH (ideal for Dubai climate conditions)" 
                    />
                    <TableRow 
                      parameter="Power Specifications" 
                      value="Input: 100~240V AC; Output: 12V/4A DC (compatible with Dubai power standards)" 
                    />
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </section>
    </div>
  )
}

const TableRow = ({ parameter, value, icon, isHighlighted = false }) => {
  return (
    <tr className={isHighlighted ? "highlighted-row" : ""}>
      <td className="parameter-cell">
        {icon && <span className="parameter-icon">{icon}</span>}
        <strong>{parameter}</strong>
      </td>
      <td className="value-cell">{value}</td>
    </tr>
  );
};

export default ZX2;